"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    root: function root(props) {
      var indent = props.variant === 'outlined' ? '-14px' : '-12px';
      return {
        display: 'inline-flex',
        flex: '0 0 auto',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.375rem 0.75rem',
        marginBottom: 0,
        fontSize: '0.84rem',
        fontWeight: typography.fontWeightRegular,
        lineHeight: 1.5,
        color: '#495057',
        backgroundColor: props.variant === 'outlined' ? '#e9ecef' : '#F0F0F0',
        border: props.variant === 'outlined' ? '1px solid #ced4da' : 0,
        borderRadius: props.position === 'left' ? 'inherit 0 0 inherit' : 'inherit inherit 0 0',
        height: '100%',
        minWidth: props.variant === 'outlined' ? 0 : 50,
        marginLeft: props.position === 'left' ? indent : 0,
        marginRight: props.position === 'left' ? 0 : indent,
        borderTopRightRadius: props.position === 'right' ? 4 : 0,
        borderTopLeftRadius: props.position === 'left' ? 4 : 0,
        borderBottomLeftRadius: props.position === 'left' ? 4 : 0,
        borderBottomRightRadius: props.position === 'right' ? 4 : 0,
        '&:hover': {
          cursor: props.onClick ? 'pointer' : 'auto'
        },
        '& svg': {
          color: 'inherit',
          marginRight: 0
        }
      };
    }
  };
}, {
  name: 'Input-icon'
});
exports.useStyles = useStyles;